module.exports = __webpack_public_path__ + "static/media/HB_buffalocauliflower_forweb_edited.cb1569c0.jpg";